import createModel from './lib/create_model';
import Endpoint from './endpoint';

/* ChannelConfiguration - Organizations have Accounts, which consist of secure credentials for configuring
 *                        the account and a list of endpoints. Non-admin users should not have access
 *                        to the full Account object as they don't need access to the secure
 *                        credentials. Users just need all the endpoints associated with all accounts,
 *                        so they can see / use them for outgoing communication.
 */

export default createModel({
  modelName: 'ChannelConfiguration',

  properties: {
    endpoints: [Endpoint],
  },

  addOrReplaceEndpoint(updatedEndpoint) {
    const index = this.endpoints.findIndex(e => e.id === updatedEndpoint.id);
    if (index !== -1) {
      this.endpoints[index] = updatedEndpoint;
    } else {
      this.endpoints.push(updatedEndpoint);
    }
  },

  removeEndpoint(endpointId) {
    this.endpoints = this.endpoints.filter(e => e.id !== endpointId);
  },

  isChannelEnabled(channel) {
    return this._endpointsWithType(channel).length > 0;
  },

  fromAddresses() {
    return this._endpointsWithType(Endpoint.Type.EMAIL);
  },

  companyInstagramAddresses() {
    return this._endpointsWithType(Endpoint.Type.INSTAGRAM_DIRECT);
  },

  companyInstagramCommentAddresses() {
    return this._endpointsWithType(Endpoint.Type.INSTAGRAM_COMMENT);
  },

  companyPhoneNumbers() {
    return this._endpointsWithType(Endpoint.Type.VOICE);
  },

  companySmsNumbers() {
    return this._endpointsWithType(Endpoint.Type.SMS);
  },

  companyWhatsAppNumbers() {
    return this._endpointsWithType(Endpoint.Type.WHATSAPP);
  },

  getEndpointsOfType(type) {
    return this._filterEndpointsByType(type);
  },

  _filterEndpointsByType(type) {
    return this.endpoints?.filter(endpoint => endpoint.type === type) || [];
  },

  _endpointsWithType(type) {
    return this._filterEndpointsByType(type).map(endpoint => endpoint.address);
  },
});
